import JshModule from '@core/scripts/helper/jsh-module';

const numberValues = {
    'days-number-label': ['Tage', 'Tag'],
    'hours-number-label': ['Stunden', 'Stunde'],
    'minutes-number-label': ['Minuten', 'Minute'],
    'seconds-number-label': ['Sekunden', 'Sekunde']
};

do {
  const {moduleScope, config} = JshModule('teaser/countdown');

  if (moduleScope !== null) {
      // data-target-date="2025-12-27T23:59:59"
      const countdownDate = new Date(moduleScope.dataset.targetDate).getTime();
      const x = setInterval(function() {
          const now = new Date().getTime();
          const distance = countdownDate - now;
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          function updateCounter(selector, value, total, maxProgress) {
              const numberElement = moduleScope.querySelector(selector);
              const progressElement = numberElement.parentElement.parentElement.querySelector('.circle-progress');
              numberElement.innerHTML = value;
              let angle = (value / total) * 360;
              if (value === 0) {
                  angle = 360;
              } else if (value >= total) {
                  angle = maxProgress;
              }

              progressElement.style.setProperty('--angle', `${angle}deg`);
          }

          function updateLabel(selector, value) {
              const labelElement = moduleScope.querySelector(`.${selector}`);
              if (labelElement) {
                  labelElement.textContent = numberValues[selector][(value === 1) ? 1 : 0];
              }
          }

          if (distance > 1) {
          updateCounter('.days-number', days, 365, 360);
              updateLabel('days-number-label', days);
          updateCounter('.hours-number', hours, 24, 360);
              updateLabel('hours-number-label', hours);
          updateCounter('.minutes-number', minutes, 60, 360);
              updateLabel('minutes-number-label', minutes);
          updateCounter('.seconds-number', seconds, 60, 360);
              updateLabel('seconds-number-label', seconds);
          }
          if (distance < 0) {
              clearInterval(x);
              const finishTextElement = moduleScope.parentElement.querySelector('.finish-text');
              if (finishTextElement) {
                  finishTextElement.removeAttribute('hidden');
              }
          }
      }, 1000);
  }

} while (document.querySelector('[jsh-module="teaser/countdown"]') !== null);
